export default __webpack_public_path__ + "static/media/united-kingdom.73528a23.png";